// src/utils/api.js

export const getApiUrl = (path) => {
  return process.env.NODE_ENV === "development"
    ? `http://localhost:5000${path}`
    : path;
};

export const getFetchOptions = (options = {}) => {
  const { headers = {}, ...otherOptions } = options;
  return {
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    ...otherOptions,
  };
};
